import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { StoreService } from '../../store/store.service';

export const lockerDetailResolver: ResolveFn<void> = async (
  route: ActivatedRouteSnapshot,
) => {
  const store = inject(StoreService);
  const {
    lockers: { setActiveLocker },
  } = store.getActions();

  await setActiveLocker(+route.paramMap.get('id')!);
  return;
};
